<template>
  <div>
    <div class="cart-table-opener row" style="margin:0" type="button" data-toggle="collapse" data-target="#collapse-cart-table"
         aria-expanded="false" @click="open = !open" aria-controls="collapse-cart-table">

      <div class="col-sm-6 text-sm-left text-center">{{ t.cart_contents }}
        <i class="fa" :class="{'fa-chevron-up':open,'fa-chevron-down':!open}" aria-hidden="true"></i></div>
      <div class="col-sm-6 text-sm-right text-center">{{ t.total_amount }}: {{ formatNumber(productData.total.gross) }}
      </div>
    </div>
    <div class="collapse" id="collapse-cart-table">
      <table class="webshop-cart-desktop">
        <tr class="table-header">
          <th>&nbsp;</th>
          <th class="product-header-h2">{{ t.name }}</th>
          <th class="product-header-h2 text-right">{{ t.cut_sizes }}</th>
          <th class="product-header-h2 text-right">{{ t.quantity }}</th>
          <th class="product-header-h2 text-right border-left">{{ t.net }}</th>
          <th class="product-header-h2 text-right">{{ t.gross }}</th>
        </tr>
        <tr v-for="(p, pidx) in productData.products" v-bind:key="pidx">
          <td v-html="p.product_image" class="product-image"></td>
          <td v-html="p.name_url" class="product-url"></td>
          <td class="text-right product-size">{{ getSizeWithRemaind(p) }}</td>
          <td class="text-right product-unit_size">
            <span v-if="p.size=='-'">{{ p.quantity }} {{ t.db }}</span>
            <span v-if="p.size=='-' && p.unit != t.db">, </span>
            <span v-if="p.unit != t.db">{{ p.unit_size }}</span>
            <span v-if="p.size!='-'">-</span>

          </td>
          <td class="text-right product-net border-left">{{ formatNumber(p.net_price) }}</td>
          <td class="text-right product-total">{{ formatNumber(p.gross_price) }}</td>
        </tr>
        <tr class="table-light">
          <td class=" product-bottom-h1" colspan="2"><b>
            <router-link :to="{ name: 'Cart' }" class="text-red">
              <i class="fa fa-arrow-left" aria-hidden="true"></i> {{ t.cart_edit }}
            </router-link>
          </b></td>
          <td class="text-right product-bottom-h1" colspan="2" v-if="productData.products_has_discount">
            <b>{{ t.total_amount }}</b></td>
          <td class="text-right product-bottom-h1" colspan="2" v-if="!productData.products_has_discount">
            <b>{{ t.total_amount }}</b></td>
          <td class="text-right total-net border-left"><b>{{ formatNumber(productData.total.net) }}</b></td>
          <td class="text-right total-total"><b>{{ formatNumber(productData.total.gross) }}</b></td>
        </tr>
      </table>
      <div class="webshop-cart-mobile">
        <div class="cart-item-data" v-for="(p, pidx) in productData.products" v-bind:key="pidx">

          <div class="row">
            <div class="col-12 product-url-mobile">
              <div class="product-image" v-html="p.product_image"></div>
              <div class="product-name" v-html="p.name_url"></div>
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-mobile">
              {{ t.cut_sizes }}
            </div>
            <div class="col-6 text-left product-size-mobile">
              {{ p.size }}
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-mobile">
              {{ t.quantity }}
            </div>
            <div class="col-6 text-left product-unit_size-mobile">
              {{ p.unit_size }}
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-mobile">
              {{ t.net }}
            </div>
            <div class="col-6 text-left product-net-mobile">
              {{ formatNumber(p.net_price) }}
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-mobile">
              {{ t.gross }}
            </div>
            <div class="col-6 text-left product-total-mobile">
              {{ formatNumber(p.gross_price) }}
            </div>
          </div>

        </div>

        <div class="cart-item-total">

          <div class="row">
            <div class="col-12 product-total-header-mobile">{{ t.altogether }}</div>
          </div>

          <div class="row" v-if="productData.products_has_discount">
            <div class="col-6 text-left product-header-h1">
              {{ t.discount }}
            </div>
            <div class="col-6 text-left product-bottom-h1">
              <strong>{{ t.total_amount }}</strong>
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-h1">
              {{ t.net }}
            </div>
            <div class="col-6 text-left total-net">
              <strong>{{ formatNumber(productData.total.net) }}</strong>
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-h1">
              {{ t.vat }}
            </div>
            <div class="col-6 text-left total-tax">
              <strong>{{ formatNumber(productData.total.tax) }}</strong>
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-left product-header-h1">
              {{ t.gross }}
            </div>
            <div class="col-6 text-left total-total">
              <strong>{{ formatNumber(productData.total.gross) }}</strong>
            </div>
          </div>
        </div>
        <div class="mt-3">
        <router-link :to="{ name: 'Cart' }" class="text-red">
          <i class="fa fa-arrow-left" aria-hidden="true"></i> <strong>{{ t.cart_edit }}</strong>
        </router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "CartTable",
  computed: {
    ...mapGetters({
      t: "getLanguageData",
      productData: "getProductData",
      orderData: "getOrderData",
      userData: "getUserData",
    }),
  },
  data() {
    return {
      open: false,
    }
  },
  methods: {
    getSizeWithRemaind: function (product){
      return product.size + (product.remainder_required?' '+this.t.with_remainder:'');
    },
    formatNumber: function (number) {
      let formatter = new Intl.NumberFormat('hu-HU', {
        style: 'currency',
        currency: this.orderData.currencyCode,
        minimumFractionDigits: 0
      });

      return formatter.format(number);
    },
  }
}
</script>

<style scoped>

</style>